import {FormCheck, Dropdown, Button} from "react-bootstrap";
import React, {Fragment, useState} from "react";
import {connect} from "react-redux";
import {showDataPoint, hideDataPoint} from '../../../actions'
import {FormGroup, Input, Label} from "reactstrap";

const DataPointItem = ({PlotData: {hide_data}, dataPoint, showDataPoint, hideDataPoint, active_plot}) => {
    const [checked, setChecked] = useState(()=>{
        if(hide_data[active_plot])
            return !hide_data[active_plot].includes(dataPoint);
        else
            return false


    });

    const changeState = () => {
        if (checked) {
            setChecked(false);
            hideDataPoint(dataPoint, active_plot);
        } else {
            setChecked(true);
            showDataPoint(dataPoint, active_plot);
        }
    };

    return (
        checked
            ? <Fragment>
                <FormGroup style={{"backgroundColor": "#f8f9fa"}} check className='wskaznikiCheckBox'>
                    <Label for={dataPoint} check>
                        <Input type="checkbox" name="dataPoint" id={dataPoint} onClick={changeState}
                               checked={checked}/>
                        <span className="form-check-sign"/>
                        {dataPoint}</Label>
                </FormGroup>
            </Fragment>


            : <Fragment >
                <FormGroup check>
                    <Label for={dataPoint} check>
                        <Input type="checkbox" name="dataPoint" id={dataPoint} onClick={changeState}
                               checked={checked}/>
                        <span className="form-check-sign"/>
                        {dataPoint}</Label>
                </FormGroup>
            </Fragment>
    );
};

const mapStateToProps = state => ({
    PlotData: state.PlotData

});
export default connect(mapStateToProps, {showDataPoint, hideDataPoint})(DataPointItem)